import { Link, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";

import { SHOPIFY_URL } from "../../utils/shopify.utils";
import ContainedButton from "../../components/Buttons/ContainedButton";

const ReturnsSlice3 = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  let navigate = useNavigate();
  return (
    <div className="col-3" style={{ maxWidth: 850 }}>
      <div
        style={{
          width: "100%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "2rem",
          marginTop: "5vh",
        }}
      >
        {t("evr-easy Exchanges")}
      </div>
      <div
        style={{
          width: "68%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "1.1rem",
          fontWeight: "bold",
          marginTop: "1vh",
        }}
      >
        {t("Free Exchange For 120 Days")}
      </div>
      <div
        style={{
          width: "72%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "1.1rem",
          marginTop: "2vh",
        }}
      >
        {t(
          "Forget the ´no quiestions´ asked policies. We ARE going to ask questions because we want to make sure you never buy another bed. Let´s keep it out of the landfill and work to make your evrbed just right."
        )}
      </div>
      <div
        style={{
          width: "72%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "1.1rem",
          marginTop: "2vh",
        }}
      >
        {t(
          "Our modular mattress design means your evrbed is easily adjustable and we offer you 120 days to get it just right. We have a 1 time free exchange on your support and comfort layers."
        )}
      </div>
      <div
        style={{
          width: "72%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "1.1rem",
          marginTop: "3vh",
        }}
      >
        {t(
          "If you need to make more than 1 exchange in the first 120 days, that isn't a problem. Sorry we didn't nail it. All we ask is you pay for the shipping and we will get it right."
        )}
      </div>
      <p
        style={{
          width: "71%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "1.1rem",
          marginTop: "3vh",
        }}
      >
        To make an exchange of if you are not sure what to adjust please email{" "}
        {<span style={{ fontWeight: "bold" }}>exchanges@evrbed.com</span>}
      </p>
      <div className="row" style={{ marginTop: "5vh" }}>
        {/*<Link*/}
        {/*  to={"contact-us"}*/}
        {/*  style={{*/}
        {/*    color: theme.COLORS.WHITE.backgroundWhite,*/}
        {/*    textDecoration: "none",*/}
        {/*    width: "auto",*/}
        {/*  }}*/}
        {/*>*/}
        <ContainedButton
          className="col-auto"
          styles={{ width: "8vw" }}
          onClick={() => {
            return (window.top.location.href = SHOPIFY_URL + "pages/contact-us");
          }}
        >
          {t("CONTACT US")}
        </ContainedButton>
        {/*</Link>*/}
        {/*<Link*/}
        {/*  to={""}*/}
        {/*  style={{*/}
        {/*    color: theme.COLORS.WHITE.backgroundWhite,*/}
        {/*    textDecoration: "none",*/}
        {/*    width: "auto",*/}
        {/*  }}*/}
        {/*>*/}
        <ContainedButton
          className="col-auto"
          color={theme.COLORS.BLUE.backgroundBlue}
          fontColor={theme.COLORS.BLUE.darkBlueGreen}
          variant="outlined"
          onClick={() => {
              return (window.top.location.href = SHOPIFY_URL + "pages/contact-us");
          }}
        >
          {t("CALL US")}
        </ContainedButton>
        {/*</Link>*/}
      </div>
    </div>
  );
};

export default ReturnsSlice3;
